import script from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"

import "./FontSelector.vue?vue&type=style&index=0&id=ea04293c&lang=scss"

const __exports__ = script;

export default __exports__